import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";
import { groupItemIdentifierStruct } from "@/modules/groups/api/resources/groupsIdentifierStruct";
import { levelIdentifierStruct } from "@/modules/levels/api/resources/level/levelIdentifierStruct";

import { achievementItemIdentifierStruct } from "./achievementIdentifierStruct";

export const achievementResourceStruct = createResourceStruct({
  identifier: achievementItemIdentifierStruct,
  attributes: sup.object({
    levelNumber: sup.nullable(sup.integer()),
    levelOrder: sup.nullable(sup.integer()),
    pointsNumber: sup.integer(),
    averageRating: sup.number(),
  }),
  relationships: sup.object({
    userGroup: sup.object({
      data: groupItemIdentifierStruct,
    }),
    level: sup.object({
      data: sup.nullable(levelIdentifierStruct),
    }),
    acknowledgedLevel: sup.object({
      data: sup.nullable(levelIdentifierStruct),
    }),
  }),
});

export type AchievementResource = sup.Infer<typeof achievementResourceStruct>;
